import React, {Component} from "react";
import PropTypes from "prop-types";
import {propTypes, reduxForm, Field} from "redux-form";
import {connect} from "react-redux";
import compose from "recompose/compose";
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import getMuiTheme from "material-ui/styles/getMuiTheme";
import RaisedButton from "material-ui/RaisedButton";
import TextField from "material-ui/TextField";
import GitInfo from "../../_git_info";
import loginStyle from "./style";
import {upperFirst} from "lodash";
import {saveConfiguration as saveConfigurationAction} from "../../actions/saveConfiguration";
import {BMTheme} from "../../BMTheme";

import {
  Notification,
  translate,
  minLength,
  email,
  userLogin as userLoginAction
} from "admin-on-rest";

const renderInput = ({
  meta: {touched, error} = {},
  input: {...inputProps},
  ...props
}) => (
  <TextField
    errorText={touched && error}
    errorStyle={loginStyle.errorStyle}
    {...inputProps}
    {...props}
    underlineStyle={loginStyle.underlineStyle}
    style={
      navigator.userAgent.toLowerCase().indexOf("android") > -1
        ? loginStyle.formContainer.textFieldAndroid
        : loginStyle.formContainer.textFieldElse
    }
  />
);

const validatePassword = [minLength(6)];

class Login extends Component {
  state = {
    instanceName: ""
  };

  async componentDidMount() {
    try {
      var response = await fetch(
        `${process.env.REACT_APP_API_URL}/configuration`,
        {
          method: "GET",
          headers: {
            Accept: "application/vnd.api+json",
            "Content-Type": "application/vnd.api+json"
          }
        }
      );
      var configuration = await response.json();
      this.props.saveConfiguration(configuration);
    } catch (e) {
      console.log("error");
    }
  }

  componentDidUpdate(nextProps) {
    if (
      this.props.configuration !== nextProps.configuration &&
      this.props.configuration.instance
    )
      this.setState({instanceName: this.props.configuration.instance.name});
  }

  login = ({username, password}) => {
    const {userLogin, location} = this.props;
    userLogin(
      {username, password},
      location.state ? location.state.nextPathname : "/"
    );
  };

  render() {
    const {handleSubmit, submitting, theme, translate} = this.props;
    const muiTheme = getMuiTheme(theme);
    const instanceName = upperFirst(this.state.instanceName);
    const INSTANCE_NAME = this.state.instanceName;
    const LOGIN_PAGE_LOGO_URL = `${process.env.REACT_APP_API_URL}/static/${INSTANCE_NAME}/crm/images/login_page_logo.png`;

    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div style={loginStyle.main}>
          <div style={loginStyle.logo}>
            {INSTANCE_NAME && <img src={LOGIN_PAGE_LOGO_URL} alt={instanceName} style={loginStyle.logo.image} />}
          </div>

          <form onSubmit={handleSubmit(this.login)} style={loginStyle.login}>
            <div style={loginStyle.formContainer}>
              <Field
                name="username"
                component={renderInput}
                placeholder={translate("loginScreen.emailField")}
                type="email"
                validate={email}
              />

              <Field
                name="password"
                component={renderInput}
                placeholder={translate("loginScreen.passwordField")}
                type="password"
                validate={validatePassword}
                autoComplete="false"
              />

              <RaisedButton
                type="submit"
                backgroundColor={BMTheme.palette.primary1Color}
                labelColor={BMTheme.palette.alternateTextColor}
                disabled={submitting}
                label={translate("loginScreen.loginButton")}
                fullWidth
                buttonStyle={
                  navigator.userAgent.toLowerCase().indexOf("android") > -1
                    ? loginStyle.button.buttonAndroidStyle
                    : loginStyle.button.buttonElseStyle
                }
                style={loginStyle.button}
                overlayStyle={loginStyle.button.buttonOverlayStyle}
                labelStyle={loginStyle.button.buttonLabelStyle}
              />
            </div>
          </form>

          <div style={loginStyle.hintContainer} />

          <div style={loginStyle.footerContainer}>
            <p
              style={
                navigator.userAgent.toLowerCase().indexOf("android") > -1
                  ? loginStyle.androidFooter
                  : loginStyle.footer
              }
            >
              Powered by {instanceName} v {GitInfo.version}
            </p>
          </div>

          <Notification />
        </div>
      </MuiThemeProvider>
    );
  }
}

Login.propTypes = {
  ...propTypes,
  authClient: PropTypes.func,
  previousRoute: PropTypes.string,
  theme: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired
};

Login.defaultProps = {
  theme: {}
};

function mapStateToProps(state) {
  return {
    configuration: state.configuration
  };
}

const enhance = compose(
  translate,
  reduxForm({
    form: "signIn",
    validate: (values, props) => {
      const errors = {};
      const {translate} = props;
      if (!values.username)
        errors.username = translate("aor.validation.required");
      if (!values.password)
        errors.password = translate("aor.validation.required");
      return errors;
    }
  }),
  connect(
    mapStateToProps,
    {
      userLogin: userLoginAction,
      saveConfiguration: saveConfigurationAction
    }
  )
);

export default translate(enhance(Login));



// WEBPACK FOOTER //
// ./src/containers/Login/index.js